const TOKEN_ERROR =
  "Internal server error .The token doesn't seem to be in a proper JWT format.";

export default TOKEN_ERROR;
